<template>
  <div>
    <v-chip
      class="font-weight-medium pa-1 mr-2"
      :text-color="percent < 0 ? 'red' : 'green'"
      :color="(percent < 0 ? 'red' : 'green') + ' lighten-4'"
      label
      small
    >
      {{ `${percent >= 0 ? "+" : ""}${percent.toFixed(2)}%` }}
    </v-chip>
    <span class="caption grey--text text--darken-2">{{ $t("this month growth") }}</span>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  name: "MonthGrowthView",
  props: {
    current: { type: Number, required: true },
    prev: { type: Number, required: true },
  },
  computed: {
    percent() {
      if (this.prev === 0 && this.current === 0) return 0;
      if (this.prev === 0) return 100;
      if (this.current === 0) return -100;
      return ((this.current - this.prev) / Math.abs(this.prev)) * 100;
    },
  },
});
</script>
